import { Box, Tooltip } from '@mui/material';

import { CopyToClipboardWrapper } from '@/components/buttons/copyToClipboardButton';
import { TextLink } from '@/components/shared/textLink';

interface DbLinkProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLocation: any;
  resourceId: string;
  copyToClipboard?: boolean;
}

function formatDbPath(dataLocation: DbLinkProps['dataLocation']): string {
  const parts: string[] = [];
  if (dataLocation?.database) parts.push(`[${dataLocation.database}]`);
  if (dataLocation?.table) parts.push(`[${dataLocation.table}]`);
  if (dataLocation?.column) parts.push(`[${dataLocation.column}]`);
  return parts.join('.');
}

export const DBLink = ({
  dataLocation,
  resourceId,
  copyToClipboard = true,
}: DbLinkProps) => {
  if (dataLocation?.sql) {
    // Truncate SQL for display, show full in tooltip
    const sql = String(dataLocation.sql);
    const truncatedSql = sql.length > 60 ? `${sql.slice(0, 60)}...` : sql;
    // Example DB Explorer link, adjust path/query as needed
    const dbExplorerUrl = `/db/${resourceId}?query=${encodeURIComponent(sql)}`;
    return (
      <CopyToClipboardWrapper textToCopy={copyToClipboard ? sql : ''}>
        <Tooltip title={sql}>
          <TextLink href={dbExplorerUrl}>{truncatedSql}</TextLink>
        </Tooltip>
      </CopyToClipboardWrapper>
    );
  }
  if (dataLocation?.database || dataLocation?.table || dataLocation?.column) {
    const fullPath = formatDbPath(dataLocation);
    return (
      <CopyToClipboardWrapper textToCopy={copyToClipboard ? fullPath : ''}>
        <Tooltip title={fullPath}>
          <Box
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {fullPath}
          </Box>
        </Tooltip>
      </CopyToClipboardWrapper>
    );
  }
};
